import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import swal from 'sweetalert2';
import { AddEditAiStatusComponent } from './addEditAiStatus.component';
import { AiStatusService } from '../../../services/index';

@Component({
    selector: 'ai-status-tab',
    templateUrl: './aiStatus.component.html',
})
export class AiStatusMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoadMask: Promise<any>;
    loadingIndicator = true;
    reorderable = true;
    suppressPaging = false;
    filterExpand = false;
    filterData = { search_data: '' };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'ai_status_name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    aiStatusData: any[] = [];
    bsModalRef: BsModalRef;

    constructor(private aiStatusService: AiStatusService, private modalService: BsModalService) {}

    ngOnInit() {
        this.columns = [
            { name: 'SNo',        prop: 'sno',            width: 70,  minWidth: 70,  maxWidth: 70,  cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'AI Status',   prop: 'ai_status_name', width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'Description', prop: 'description',    width: 300, minWidth: 300, maxWidth: 300 },
            { name: 'Status',      prop: 'status',         width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Action',     prop: 'ai_status_id',   width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: any) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getList();
        }
    }

    onOpenedFilter() {}

    clearFilter() {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter() {
        this.filterPanel.close();
        this.getList();
    }

    sortCallback(sortInfo: any) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy  = sortInfo.sorts[0].prop;
        this.getList();
    }

    onChangePageSize(limit: number) {
        this.page.limit = limit;
        this.getList();
    }

    getList() {
        const params = {
            start:       `${this.page.offset}`,
            limit:       `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir:    `${this.page.orderDir}`,
            filter:      JSON.stringify(this.filterData)
        };
        this.isLoadMask = this.aiStatusService.getList(params).then((res: any) => {
            this.loadingIndicator = false;
            this.page.count  = res.totCnt;
            this.aiStatusData = res.data;
        });
    }

    onAddEdit(mode: string, row: any) {
        this.bsModalRef = this.modalService.show(AddEditAiStatusComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title         = mode + ' AI Status';
        this.bsModalRef.content.aiStatusData  = Object.assign({}, row);
        this.bsModalRef.content.loadEvent.subscribe(() => { this.getList(); });
    }

    onDelete(row: any) {
        swal({
            title: 'Are you sure to Delete?',
            text: 'Delete AI Status: ' + row.ai_status_name + '?',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(() => {
            this.isLoadMask = this.aiStatusService.delete(row.ai_status_id).then((res: any) => {
                if (res.success) {
                    this.getList();
                    swal('Deleted', res.message, 'success');
                } else {
                    swal('ERROR', res.message, 'error');
                }
            });
        }, () => {});
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/aiStatus/aiStatus.component.ts